export const STORAGE_KEY = 'sunny-bounce.web.v1';
export interface Preferences {
  version: 1;
  /** Legacy v1 score remains the casual record. */
  best: number;
  challengeBest: number;
  challengeStage: number;
  theme: string;
  sound: boolean;
  language: 'en' | 'zh';
  /** True only after an explicit language-button choice. */
  manualLanguage: boolean;
}
export function validScore(value: unknown): number {
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 ? value : 0;
}
export function parsePreferences(raw: string | null): Preferences {
  let data: Partial<Preferences> = {};
  try { data = JSON.parse(raw ?? '{}') ?? {}; } catch { /* Treat old/corrupt data as an empty record. */ }
  const hasValidLanguage = data.language === 'zh' || data.language === 'en';
  return { version: 1, best: validScore(data.best), challengeBest: validScore(data.challengeBest),
    challengeStage: validScore(data.challengeStage), theme: typeof data.theme === 'string' ? data.theme : 'jelly',
    sound: typeof data.sound === 'boolean' ? data.sound : true, language: data.language === 'zh' ? 'zh' : 'en',
    manualLanguage: data.manualLanguage === true && hasValidLanguage };
}
export class RecordStore {
  data: Preferences;
  available = true;
  constructor(private readonly storage: Pick<Storage, 'getItem' | 'setItem'> | null) {
    try { this.data = parsePreferences(storage?.getItem(STORAGE_KEY) ?? null); if (!storage) this.available = false; }
    catch { this.data = parsePreferences(null); this.available = false; }
  }
  save(patch: Partial<Preferences>) {
    let other = parsePreferences(null);
    try {
      other = parsePreferences(this.storage?.getItem(STORAGE_KEY) ?? null);
      if (other.manualLanguage && patch.manualLanguage === undefined) {
        this.data.language = other.language; this.data.manualLanguage = true;
      }
    } catch { this.available = false; }
    this.data = { ...this.data, ...patch, version: 1,
      best: Math.max(this.data.best, validScore(patch.best), other.best),
      challengeBest: Math.max(this.data.challengeBest, validScore(patch.challengeBest), other.challengeBest),
      challengeStage: Math.max(this.data.challengeStage, validScore(patch.challengeStage), other.challengeStage) };
    try { if (this.storage) this.storage.setItem(STORAGE_KEY, JSON.stringify(this.data)); else this.available = false; }
    catch { this.available = false; }
    return this.data;
  }
  mergeExternal(raw: string | null) {
    const other = parsePreferences(raw);
    this.data.best = Math.max(this.data.best, other.best);
    this.data.challengeBest = Math.max(this.data.challengeBest, other.challengeBest);
    this.data.challengeStage = Math.max(this.data.challengeStage, other.challengeStage);
    if (other.manualLanguage) { this.data.language = other.language; this.data.manualLanguage = true; }
  }
}
